import React from "react";
import {sendGAEvent} from "../../../domain/marketing/gtm-provider";

export const MainBannerWCATopNew = () => {
    const scrollToPlans = () => {
        const $el = document.getElementById('plans-container');
        if(!$el) return;

        window.scrollTo({
            top: $el.offsetTop,
            left: 0,
            behavior: "smooth",
        });
    }
    const handleMainBannerClick = (e: React.MouseEvent<HTMLDivElement>) => {
        const target = e.target as HTMLElement;
        const closestWithPopup = target.closest('[data-youtube-popup]');

        if (closestWithPopup) {
            sendGAEvent('Click', 'video popup');
            return;
        }
        sendGAEvent('Click', 'scroll to plans');
        scrollToPlans();
    };
    return (
        <>
                {/*<div className="main-bnr pb-2 md:pb-2 cursor-pointer" onClick={scrollToPlans} >*/}
                <div className="main-bnr pb-2 md:pb-2 cursor-pointer pt-8 md:pt-8 lg:pt-12" onClick={handleMainBannerClick}>
                    <section className="main-bnr w-full">
                        <div className="w-full text-center md:text-center md:pl-12">
                            <div
                                className="top-title w-full text-2xl md:text-4xl lg:text-6xl line-height-normal font-bold font-montserrat">
                                <h1 className="w-full text-yellow-400">
                                    Waves Creative Access
                                </h1>
                            </div>
                        </div>
                    </section>
                </div>

        </>
    )
};